var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbarItemMobile",class:{ activeMobile: _vm.isActive },on:{"click":function($event){return _vm.onHandleClick()}}},[_c('div',{staticClass:"iconItem"},[_c('b-icon',{attrs:{"pack":"fas","icon":_vm.icon}})],1),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v("\n    "+_vm._s(this.name)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f0cff9a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/navbarMobile/navbarItem.vue
// module id = null
// module chunks = 